// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"96aa5457","362":"b8804550","389":"05767c28","807":"5d2e38c4","903":"1f905421"}[chunkId] + ".css";
};